package com.essntl.core.settings.data.supabase.feature

import com.essntl.core.supabase.SupabaseDataSource
import io.github.jan.supabase.SupabaseClient
import org.koin.core.annotation.Single

@Single
class AllowedFeatureSupabaseDataSource(
    override val supabaseClient: SupabaseClient,
) : SupabaseDataSource<AllowedFeaturesDto> {
    override val tableName: String = "tenant_features"
}